export const SNG_OPEN_POPUP = 'sng-open-popup'
export const SNG_PAGE_CHANGE = 'sng-page-change'
